import getIn from 'transmute/getIn';
import { useGetDataProperty } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataProperty';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DataSourcePropertyNameWithFallback = ({
  token,
  fallbackLabel = ''
}) => {
  const {
    prefix,
    property
  } = getTokenParts(token);
  const {
    data,
    loading,
    error
  } = useGetDataProperty({
    prefix,
    property
  });
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "skeleton-loader-data-source-property-name"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: fallbackLabel
    });
  }
  const maybeDataPropertyName = getIn(['dataSourceProperty', 'label'], data);
  if (maybeDataPropertyName) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: maybeDataPropertyName
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: fallbackLabel
  });
};
export default DataSourcePropertyNameWithFallback;